import { useState ,  useEffect, useCallback } from "react";

import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomChip from "../../../components/mui/chip";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { GetCustomer } from "./GetCustomer";
import { filterData } from "./filterData";
import { GetJobsite } from "./GetJobsites";
import { GetContacts } from "./GetContacts";
import Icon from "../../../components/icon";
import NProgress from "react-nprogress";
import { DeleteContact } from "./DeleteContact";
import { SaveContact } from "./SaveContacts";
import { GetAlerts } from "./GetAlerts";
import { GetPropertyArea } from "./GetPropertyArea";
import { SaveIndividual } from "./SaveIndividual";
import { DeleteCustomer } from "./DeleteCustomer";
import { DeleteJobsite } from "./DeleteJobsite";
import _ from 'lodash';
import { getTimeZone } from "../../../components/US_Timezones";
import { useDropzone } from "react-dropzone";
import { SaveBulkCustomer } from "./BulkSave";
import { exportToCSV } from "../../../components/export-components/ExportToCSV";
import { getCurrentDate } from "../../../components/formatDate";
import ExportToExcel from "../../../components/export-components/ExportExcel";
import { useCustomerPermission } from "../permissions/CustomerPermissions";
import { useJobsitePermission } from "../permissions/JobsitePermissions";

export const useIndexLogic = () => {
  //#region Permissions
  const { PermissionProps } = useCustomerPermission();
  const {
    hasSavePermission,
    hasGetPermission,
    hasSaveIndividualPermission,
  } = PermissionProps;

  const { JobsitePermissionProps } = useJobsitePermission();
  const {
    hasJobsiteSavePermission,
    hasJobsiteDeletePermission,
  } = JobsitePermissionProps;
  //#endregion Permissions

  //#region Constants
  const theme = useTheme();
  const navigate = useNavigate();
  const contentHeightFixed = false; 


  const tagManagementData = { title: 'Tag Management' }

  const InitialpropertyArea = {
    propertyAreaID: 0,
    jobsiteID: 0,
    propertyAreaType: 'Indoor',
    propertyAreaName: null,
    description: null,
    measurement: null,
  }

  const keysToKeep = [
    'customerID',
    'companyName',
    'customerType',
    'firstName',
    'companyAddress_Street1',
    'createDate',
    'createdBy',
    'modifiedDate',
    'modifiedBy',
    'referredBy',
    'isActive',
    'isLead',
    'tags',
  ];



  //#endregion End of Constants

  //#region States

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [bulkCusType, setBulkCusType] = useState(0);
  const [bulkCusStatus, setBulkCusStatus] = useState(0);
  const [bulkCusLead, setBulkCusLead] = useState(0);
  const [bulkTags, setBulkTags] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [data, setData] = useState([]);
  const [paginationText, setPaginationText] = useState('');
  const [openNewCustomerDlg, setOpenNewCustomerDlg] = useState(false);
  const [phoneFields, setPhoneFields] = useState([
    { phoneNo: "", isPrimary: true },
  ]);
  const initialCustomerState = {
    customerID: 0,
    customerType: 'individual',
    firstName: '',
    lastName: '',
    createDate: null,
    createBy: null,
    modifiedDate: null,
    modifiedBy: null,
    isActive: true,
    companyName: '',
    email: '',
    isLead: false,
    referredBy: '',
    companyAddress_Street1: '',
    companyAddress_Street2: '',
    companyAddress_FloorLevel: '',
    companyAddress_UnitNumber: '',
    companyAddress_City: '',
    companyAddress_State: '',
    companyAddress_ZipCode: '',
    companyAddress_County: '',
    billingAddress: true,
    billingAddress_Street1: '',
    billingAddress_Street2: '',
    billingAddress_FloorLevel: '',
    billingAddress_UnitNumber: '',
    billingAddress_City: '',
    billingAddress_State: '',
    billingAddress_ZipCode: '',
    billingAddress_County: '',
    timeZone: '',
    phoneNumbers: phoneFields,
    createdBy: null,
    tags: [],
  }
  
  const [openTagManagementDlg,setOpenTagManagementDlg] = useState(false);
  const [customer, setCustomer] = useState(initialCustomerState);
  const [allCustomers, setAllCustomers] = useState([]);
  const [allJobsites, setAllJobsites] = useState([]);
  const [flattenedJobsitesData, setFlattenedJobsitesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quickViewOpen, setQuickViewOpen] = useState(false);
  const [selectedJobsite, setSelectedJobsite] = useState(null);
  const [alertList, setAlertList] = useState([]);
  const [propertyAreaList, setPropertyAreaList] = useState([]);
  
  // AddJobsite Dialog states
  const [openNewJobsiteDlg, setOpenNewJobsiteDlg] = useState(false);
  const [jobsiteForEdit, setJobsiteForEdit] = useState(null);
  const [jobsiteContent, setJobsiteContent] = useState({ title: "Edit Jobsite", notification: "Jobsite updated successfully.", mode: 'edit' });
  const [activeStepJobsite, setActiveStepJobsite] = useState(0);
  const [propertyArea, setPropertyArea] = useState(InitialpropertyArea);
    const [areaMeasurement, setAreaMeasurement] = useState({
      measurementID: 0,
      measurementName: null,
      unitOfMeasure: null,
      length: 0,
      width: 0,
      height: 0,
      total: 0,
    });
  const [files, setFiles] = useState([]);
  const [listOfMeasurements, setListOfMeasurements] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState('ALL');
  const [selectedButton, setSelectedButton] = useState(0);
  const [showJobsites, setShowJobsites] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState(0);  
  const [openBulkImportDlg, setOpenBulkImportDlg] = useState(false);
  const [EmpFiles, setEmpFiles] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const MySwal = withReactContent(Swal)

  const [BulkImportContent, setBulkImportContent] = useState({title:'', ImportURL:''});
  
  const [contactID, setContactID] = useState(0);
  const initialContact = {
    contactID: 0,
    firstName: null,
    lastName: null,
    email: null,
    jobTitle: null,
    customerID: 0,
    isPrimary: null,
    phoneNumbers:phoneFields,
    status:'active'
  }
  const [contact, setContact] = useState(initialContact);
  const [allContacts, setAllContacts] = useState([]);


  //#endregion end of states

  //#region Handlers and methods

 const fetchData = async () => {
  if(!hasGetPermission) return;

  setLoading(true);
  try {
    // Fetch customers
    let cus = await GetCustomer(0, navigate);
    
    // Add Fullname property to each customer
    const customersWithFullname = cus.map(customer => ({
      ...customer,
      Fullname: customer.customerType === 'Individual' 
        ? `${customer.firstName || ''} ${customer.lastName || ''}`.trim()
        : customer.companyName || ''
    }));
    
    const filteredData = filterData(customersWithFullname, [...keysToKeep, 'Fullname']);
    setData(prev => JSON.stringify(prev) !== JSON.stringify(filteredData)? filteredData : prev);
    setAllCustomers(prevCustomers =>
      JSON.stringify(prevCustomers) !== JSON.stringify(cus) ? cus : prevCustomers
    );

      // Fetch all jobsites
      let jobsites = await GetJobsite(0, 0, navigate);
      setAllJobsites(prevJobsites =>
        JSON.stringify(prevJobsites) !== JSON.stringify(jobsites) ? jobsites : prevJobsites
      );

      // Fetch all contacts
      let allContacts = await GetContacts(0);

      // Merge customers and jobsites based on customerID, and attach contacts to jobsites
      const mergedData = cus.map(customer => {
        const customerJobsites = jobsites.filter(jobsite => jobsite.customerID === customer.customerID);
        
        // For each jobsite, attach the full contact details
        const jobsitesWithContacts = customerJobsites.map(jobsite => {
          let attachedContacts = [];
          
          // If jobsite has contacts array, match them with full contact details
          if (jobsite.contact && Array.isArray(jobsite.contact)) {
            attachedContacts = jobsite.contact.map(contactRef => {
              const fullContact = allContacts.find(contact => contact.id === contactRef.contactID);
              return {
                ...contactRef,
                contactDetails: fullContact || null
              };
            });
          }
          
          return {
            ...jobsite,
            contactsWithDetails: attachedContacts
          };
        });
        
        return {
          ...customer,
          jobsites: jobsitesWithContacts
        };
      });

      // Create flattened jobsites data for the grid
      const flattenedJobsites = [];
      mergedData.forEach(customer => {
        if (customer.jobsites && customer.jobsites.length > 0) {
          customer.jobsites.forEach(jobsite => {
            // Build jobsite address based on billingAddress flag
            let jobsiteAddress = '';
            if (jobsite.billingAddress === true) {
              // Use customer's billing address
              const addressParts = [
                customer.companyAddress_Street1,
                customer.companyAddress_City,
                customer.companyAddress_State,
                customer.companyAddress_ZipCode
              ].filter(part => part && part.trim() !== '');
              jobsiteAddress = addressParts.join(', ');
            } else {
              // Use jobsite's own address
              const addressParts = [
                jobsite.street1,
                jobsite.city,
                jobsite.state,
                jobsite.zipCode
              ].filter(part => part && part.trim() !== '');
              jobsiteAddress = addressParts.join(', ');
            }

            flattenedJobsites.push({
              id: jobsite.jobsiteID,
              jobsiteID: jobsite.jobsiteID,
              jobsiteName: jobsite.jobsiteName,
              jobsiteAddress: jobsiteAddress,
              jobsiteType: jobsite.jobsiteType,
              customerID: customer.customerID,
              customerType: customer.customerType,
              companyName: customer.companyName,
              firstName: customer.firstName,
              lastName: customer.lastName,
              isLead: customer.isLead,
              contactsWithDetails: jobsite.contactsWithDetails || [],
              contact: jobsite.contact || [], // Add original contact array for QuickView
              // Include other jobsite properties if needed
              street1: jobsite.street1,
              city: jobsite.city,
              state: jobsite.state,
              zipCode: jobsite.zipCode,
              billingAddress: jobsite.billingAddress,
              isActive: jobsite.isActive
            });
          });
        }
      });

      setFlattenedJobsitesData(flattenedJobsites);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  

  const handleSearchChange = (searchKeyWord) => {
    setSearchText(searchKeyWord);
  };

  const handleOpenNewCustomerDlg = () => {    
    setOpenNewCustomerDlg(true);
  };

  const filteredRows = !hasGetPermission ? [] : (isFiltered 
    ? filterData(filteredData, keysToKeep) 
    : data || [])
  .filter(row => {    
      if (filterType === 'Lead') {
          return  row.isLead === 'Lead';
      } else if (filterType === 'NL') {
          return row.isLead === 'NL';
      }   
      return true;
  })
  .filter(row =>    
      Object.values(row).some(value =>
          value && value.toString().toLowerCase().includes(searchText.toLowerCase())
      )
  );

  // Filtered jobsites for search functionality with enhanced search for Lead and Contact columns
  const filteredJobsitesRows = flattenedJobsitesData.filter(row => {
    const searchTerm = searchText.toLowerCase();
    
    // Search in basic fields
    const basicFieldsMatch = Object.values(row).some(value =>
      value && value.toString().toLowerCase().includes(searchTerm)
    );
    
    // Search in Lead column (convert boolean to "Lead" text)
    const leadMatch = row.isLead === true && "lead".includes(searchTerm);
    
    // Search in Jobsite Contact column (nested email)
    const primaryContact = row.contactsWithDetails?.find(contact => contact.isPrimary);
    const contactEmail = primaryContact?.contactDetails?.email;
    const contactMatch = contactEmail && contactEmail.toLowerCase().includes(searchTerm);
    
    return basicFieldsMatch || leadMatch || contactMatch;
  });

  useEffect(() => {
    const total = showJobsites ? filteredJobsitesRows.length : filteredRows.length;
    let start = paginationModel.page * paginationModel.pageSize + 1;
    let end = Math.min((paginationModel.page + 1) * paginationModel.pageSize, total);
  
    if (total === 0) {
      setPaginationText("0-0 of 0");
      return;
    }

    if (paginationModel.pageSize === -1) {
      start = 1;
      end = total;
    }
  
    setPaginationText(`${start}-${end} of ${total}`);
  }, [filteredRows, paginationModel.page, paginationModel.pageSize, showJobsites, filteredJobsitesRows]);

  useEffect(() => {
    if(hasGetPermission){
      fetchData();
    }
  }, [data,allCustomers, hasGetPermission]);


  const applyFilters = (filters) => {

    const filtered = allCustomers.filter((customer) => {

      const matchesFullName =
        !filters.fullName ||
        (customer.firstName &&
          customer.firstName.trim().toLowerCase().includes(filters.fullName.trim().toLowerCase())) ||
        (customer.lastName &&
          customer.lastName.trim().toLowerCase().includes(filters.fullName.trim().toLowerCase()));

      const matchesCustomerType =
        !filters.customerType || customer.customerType === filters.customerType;

      const matchesEmail =
      !filters.email || (customer.email && customer.email.includes(filters.email));

      const matchesPhoneNumber =
        !filters.phoneNumber ||
        (customer.phoneNumbers &&
          customer.phoneNumbers.some((phone) =>
            phone.phoneNo.includes(filters.phoneNumber)
          ));

      const matchesStatus =
        filters.status === undefined ||
        filters.status === "" ||
        customer.isActive === filters.status;       

        const matchesCompanyName =
        !filters.companyName || (customer.companyName &&  customer.companyName.toLowerCase().includes(filters.companyName.toLowerCase()));

        const matchesAddress =
          !filters.address ||
          (customer.companyAddress_Street1 &&
            customer.companyAddress_Street1.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_Street2 &&
            customer.companyAddress_Street2.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_City &&
            customer.companyAddress_City.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_State &&
            customer.companyAddress_State.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_ZipCode &&
            customer.companyAddress_ZipCode.toLowerCase().includes(filters.address.toLowerCase())) ||
          (customer.companyAddress_County &&
            customer.companyAddress_County.toLowerCase().includes(filters.address.toLowerCase()));

          const matchesBillingAddress =
          !filters.billing_address ||
          (customer.billingAddress_Street1 &&
            customer.billingAddress_Street1.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_Street2 &&
            customer.billingAddress_Street2.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_City &&
            customer.billingAddress_City.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_State &&
            customer.billingAddress_State.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_ZipCode &&
            customer.billingAddress_ZipCode.toLowerCase().includes(filters.billing_address.toLowerCase())) ||
          (customer.billingAddress_County &&
            customer.billingAddress_County.toLowerCase().includes(filters.billing_address.toLowerCase()));
           
      const matchesTags =
        !filters.tags.length ||
        (customer.tags &&
          filters.tags.every((tag) => customer.tags.includes(tag)));

      // Combine all conditions
      return (
        matchesFullName &&
        matchesPhoneNumber &&
        matchesEmail &&
        matchesAddress &&
        matchesTags &&
        matchesCustomerType &&
        matchesStatus &&
        matchesCompanyName &&
        matchesBillingAddress
      );
    });

    setFilteredData(filtered);
    setIsFiltered(true);

  };

  const handleReset = () => {
    setFilteredData(allCustomers); // Reset to show all employees
    setIsFiltered(false);
  };

  
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 2000000, // 2 MB in bytes
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onDrop: acceptedFiles => {
      setBtnLoader(true);  
      setTimeout(() => {
        setEmpFiles(acceptedFiles.map(file => Object.assign(file)));
        setBtnLoader(false); 
      }, 1000);  // Simulating a delay for loading effect
    },
    onDropRejected: () => {
      toast.error('You can only upload 1 file with a maximum size of 2 MB.', {
       duration: 2000,   
    style: {
      fontFamily: '"DM Sans", sans-serif',
      fontSize: '15px',
    },
  });
      //setMessage('You can only upload 1 file with a maximum size of 2 MB.');
      setBtnLoader(false);
    }
  });

  const calculateContentWidth = (rows, field) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = "15px Lexend"; // Match the font used in your grid
  
    let maxWidth = 130; // Minimum width
    rows.forEach((row) => {
      const textWidth = context.measureText(row[field]).width;
      maxWidth = Math.max(maxWidth, textWidth + 16); // Add some padding
    });
  
    return maxWidth;
  };

  const [Tag, setTag]  = useState('');

  const handleOpenTagManagementDlg = (tags, id) => {
    
    setCustomer(getCustomerById(id));
    setOpenTagManagementDlg(true);
  }

  const handleAddTag = async (tagName) => {
    if (tagName.trim() === '') return;
  
    const lowerCaseTagName = tagName.toLowerCase();
  
    const tagExists = customer && customer.tags && customer.tags.some(
      (tag) => tag.tagName.toLowerCase() === lowerCaseTagName
    );
  
    if (tagExists) return;
  
    const updatedTags = [...(customer.tags || []), { tagName }];
    const updatedCustomer = {
      ...customer,
      tags: updatedTags,
    };
  
    setCustomer(updatedCustomer);
    setTag('');
  
    try {
      await SaveIndividual(updatedCustomer,null,navigate);
      await fetchData();
    } catch (error) {
      console.error('Error saving tag:', error);
    }
  };

  const handleDeleteTag = async (tagName) => {
    const updatedTags = customer.tags.filter(tag => tag.tagName !== tagName);
  
    const updatedCustomer = {
      ...customer,
      tags: updatedTags,
    };
  
    setCustomer(updatedCustomer);
  
    try {
      await SaveIndividual(updatedCustomer, null, navigate);  
      await fetchData();
    } catch (error) {
      console.error('Error deleting tag:', error);
    }
  };

 const handleDeleteTagByID = async (tagName, id) => {
  try {
    // Update local state optimistically
    const updatedCustomer = {
      ...customer,
      tags: customer.tags.filter(tag => tag.tagName !== tagName)
    };
    
    // Update the allCustomers array
    setAllCustomers(prev => prev.map(c => 
      c.customerID === id ? updatedCustomer : c
    ));
    
    setCustomer(updatedCustomer);
    
    // Save to server
    await SaveIndividual(updatedCustomer, null, navigate);
    
    // Optional: refresh data from server to ensure sync
    await fetchData();
  } catch (error) {
    console.error('Error deleting tag by ID:', error);
    // Revert state if API call fails
    fetchData();
  }
};

  const columns = [
    {
      flex: 0.1,
      field: "id",
      hide: true,
      minWidth: 50,
      headerName: "ID",
      renderCell: ({ row }) => {
        const { id } = row;

        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%",
              cursor:'pointer', 
              '&:hover' : {
                textDecoration:'underline'
              },
             }} 
            onClick={() => navigate(`/customers/detail/${id}`)}
          >
            <Typography sx={{ flexGrow: 1 }}>{id}</Typography>
          </Box>
        );
      },
    },
    {
      field: "Fullname",
      minWidth: calculateContentWidth(data, 'Fullname'),
      headerName: "Name",
      sortable: true,
      sortingOrder: ['asc', 'desc'],
      renderCell: ({ row }) => {
        const { Fullname, id, companyName, customerType } = row;
        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%", 
              cursor:'pointer' , 
              '&:hover' : {
                textDecoration:'underline'
              },
          }}
            onClick={() => navigate(`/customers/detail/${id}`)}
          >
            <Typography>{customerType === 'Individual' ? Fullname : companyName}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "customerType",
      minWidth: 120,
      headerName: "Type",
      renderCell: ({ row }) => {
        const { customerType } = row;
        return (
          <>
            <CustomChip
              rounded
              size="small"
              skin={theme.palette.mode === 'dark' ? 'light' : 'dark'}
              sx={{ lineHeight: 1, cursor: 'pointer' }}
              color={customerType === "Individual" ? "warning" : "info"} //'success' // Use color names: primary, secondary, error, warning, info, success
              label={customerType}
            />
          </>
        );
      },
    },
    {
      flex: 0.1,
      field: "isLead",
      minWidth: 85,
      editable: hasSaveIndividualPermission ? true : false,
      headerName: "Lead",
      renderCell: ({ row }) => {
        const { isLead } = row;
        return (
          <>
            { isLead === "Lead" ? (
            <CustomChip
                rounded
                size="small"
                skin="light"
                sx={{ lineHeight: 1, cursor: 'pointer',
                  '&:hover' : {
                    transform: 'scale(1.05, 1.05)'
                  }
                  }}
                color={"success"}
                label={isLead}
              />
          ) : (
            <Typography sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>-</Typography>
          ) }
         </>
        )
      },
    },
    {
      flex: 0.1,
      field: "companyAddress_Street1",
      minWidth: 120,
      headerName: "Address",
      renderCell: ({ row }) => {
        const { companyAddress_Street1 } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%",
            '&:hover' : {
                  transform: 'scale(1.05, 1.05)'
                }
           }}>
            <Typography sx={{ flexGrow: 1 }}>
              {companyAddress_Street1}
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "createDate",
      minWidth: 140,
      headerName: "Created On",
      renderCell: ({ row }) => {
        const { createDate } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{createDate}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "createdBy",
      minWidth: 120,
      headerName: "Created By",
      renderCell: ({ row }) => {
        const { createdBy } = row;
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{createdBy}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "lastService",
      hide: true,
      minWidth: 120,
      headerName: "Last Service",
      renderCell: ({ row }) => {
        const { lastService } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{lastService}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "lastActivity",
      hide: true,
      minWidth: 120,
      headerName: "Last Activity",
      renderCell: ({ row }) => {
        const { lastActivity } = row;

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{lastActivity}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "referredBy",
      minWidth: 120,
      headerName: "Referred By",
      renderCell: ({ row }) => {
        const { referredBy } = row;

        const referrer = allCustomers.find((c) => c.customerID === referredBy)

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", cursor: 'default' }}>
            <Typography sx={{ flexGrow: 1 }}>{
              referrer ? (
                referrer.firstName || referrer.lastName ? 
                `${referrer?.firstName} ${referrer?.lastName}` :
                referrer.companyName ?
                `${referrer?.companyName}` :
                '-'
              ) : '-'
            }
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "isActive",
      minWidth: 95,
      headerName: "Status",
      renderCell: ({ row }) => {
        const { isActive } = row;

        return (
          <CustomChip
            rounded
            size="small"
            skin="light"
            sx={{ lineHeight: 1, cursor: 'pointer',
              '&:hover' : {
                  transform: 'scale(1.05, 1.05)'
                }
             }}
            color={isActive === "Active" ? "success" : "secondary"} //'success' // Use color names: primary, secondary, error, warning, info, success
            label={isActive}
          />
        );
      },
    },
    {
      flex: 0.1,
      field: "tags",
      minWidth: 280,
      // minWidth: calculateContentWidth(data, 'tags'),
      headerName: "Tags",
      renderCell: ({ row }) => {
        const { tags, id } = row;

        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "nowrap",
              alignItems: "center",
              height: "100%",
            }}
          >
            {hasSaveIndividualPermission ? (
              <CustomChip
                rounded
                label="Add"
                size="small"
                color="info"
                skin="light"
                sx={{ lineHeight: 1 }}
                onDelete={() => handleOpenTagManagementDlg(tags, id)}
                deleteIcon={<Icon icon="tabler:circle-plus" />}
                // onClick={() => handleOpenTagManagementDlg(tags, id)}
              />
            ) : (<></>)}

            {tags && tags.length > 0 ? (
              tags.length <= 2 ? (
                tags.map((tag, index) => (
                  <CustomChip
                    key={index}
                    rounded
                    label={tag.tagName}
                    size="small"
                    color="info"
                    skin="light"
                    sx={{ lineHeight: 1 }}
                    {...(hasSaveIndividualPermission && { onDelete: () => handleDeleteTagByID(tag.tagName, id) })}
                    // onDelete={() => handleDeleteTagByID(tag.tagName, id)}
                  />
                ))
              ) : (
                <>
                  <CustomChip
                    rounded
                    label={tags[0].tagName}
                    size="small"
                    color="info"
                    skin="light"
                    sx={{ lineHeight: 1 }}
                    {...(hasSaveIndividualPermission && { onDelete: () => handleDeleteTagByID(tags[0].tagName, id) })}
                  />
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ display: "inline-flex", alignItems: "center" }}
                  >
                    ...
                  </Typography>
                  <CustomChip
                    rounded
                    label="See More"
                    size="small"
                    color="info"
                    skin="light"
                    sx={{ 
                      lineHeight: 1,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 58, 112, 0.16)',
                      },  
                    }}
                    onClick={() => handleOpenTagManagementDlg(tags, id)}
                  />
                </>
              )
            ) : (
              <Typography variant="body2" color="textSecondary">
                No tags
              </Typography>
            )}
          </Box>
        );
      },
    },
  ];

  // Jobsites columns (6 columns as requested)
  const jobsitesColumns = [
   {
    field: "jobsite",
    headerName: "Jobsite",
    minWidth: 280,
    flex: 0.25,
    renderCell: (params) => {
      const { row } = params;

      const handleJobsiteClick = () => {
        if (hasJobsiteSavePermission) {
          // Use the new tabbed handler instead of edit handler
          handleJobsiteTabbedEdit(row.jobsiteID);
        }
      };

      return (
        <Box
          onClick={handleJobsiteClick}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
            paddingLeft: 3,
            cursor: hasJobsiteSavePermission ? 'pointer' : 'default',
            '&:hover': hasJobsiteSavePermission ? {
              '& .jobsite-name': {
                textDecoration: 'underline'
              }
            } : {},
          }}
        >
          <Typography
            noWrap
            variant="body2"
            className="jobsite-name"
            sx={{ color: "text.primary", fontWeight: 600 }}
          >
            {row.jobsiteName}
          </Typography>
          <Typography noWrap color="text.secondary" fontSize="small">
            {row.jobsiteAddress}
          </Typography>
        </Box>
      );
    },
  },
    {
      field: "customerName",
      headerName: "Customer Name",
      minWidth: 220,
      flex: 0.2,
      renderCell: ({ row }) => {
        const { customerType, companyName, firstName, lastName, customerID } = row;
        const displayName = customerType === "Business" 
          ? companyName 
          : `${firstName || ''} ${lastName || ''}`.trim();
        
        const handleCustomerClick = () => {
          navigate(`/customers/detail/${customerID}`);
        };
        
        return (
          <Box 
            onClick={handleCustomerClick}
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%", 
              cursor:'pointer' , 
              '&:hover' : {
                '& .customer-name': {
                  textDecoration:'underline'
                }
              },
          }}
          >
            <Typography noWrap className="customer-name" sx={{ flexGrow: 1 }}>{displayName}</Typography>
          </Box>
        );
      },
    },
    {
      field: "jobsiteType",
      headerName: "Jobsite Type",
      minWidth: 140,
      flex: 0.15,
      renderCell: ({ row }) => {
        const { jobsiteType } = row;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            {jobsiteType && (
              <CustomChip
                rounded
                size="small"
                skin="light"
                sx={{ 
                  lineHeight: 1, 
                  cursor: 'pointer',
                  '&:hover' : {
                    transform: 'scale(1.05, 1.05)'
                  }
                }}
                color={jobsiteType === "Commercial" ? "warning" : "info"}
                label={jobsiteType}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: "isLead",
      headerName: "Lead",
      minWidth: 100,
      flex: 0.1,
      renderCell: ({ row }) => {
        const { isLead } = row;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            {isLead === true && (
              <CustomChip
                rounded
                size="small"
                skin="light"
                sx={{ 
                  lineHeight: 1, 
                  cursor: 'pointer',
                  '&:hover' : {
                    transform: 'scale(1.05, 1.05)'
                  }
                }}
                color="success"
                label="Lead"
              />
            )}
          </Box>
        );
      },
    },
    {
      field: "jobsiteContact",
      headerName: "Jobsite Contact",
      minWidth: 250,
      flex: 0.2,
      renderCell: ({ row }) => {
        const { contactsWithDetails } = row;
        const primaryContact = contactsWithDetails?.find(contact => contact.isPrimary);
        const contactEmail = primaryContact?.contactDetails?.email;
        return (
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            height: "100%"
          }}>
            <Typography noWrap sx={{ flexGrow: 1 }}>
              {contactEmail}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 150,
      flex: 0.1,
      sortable: false,
      renderCell: ({ row }) => {
        const { jobsiteID, jobsiteName } = row;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%", gap: 0.5 }}>
            <IconButton 
              onClick={() => handleQuickViewOpen(jobsiteID)}
              size="small"
              sx={{ color: 'text.secondary' }}
            >
              <Icon icon='tabler:eye' fontSize="1.25rem" />
            </IconButton>
            <IconButton 
              color='error'
              disabled={!hasJobsiteDeletePermission}
              size="small"
              {...(hasJobsiteDeletePermission && {
                onClick: () => handleJobsiteDelete(jobsiteID, jobsiteName)
              })}
            >
              <Icon icon='tabler:trash' fontSize="1.25rem" />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleFilterTypeChange = (buttonIndex,type) => {
    setFilterType(type);  
    setSelectedButton(buttonIndex);        
    setShowJobsites(type === "Jobsites");
    setPaginationModel((prevModel) => ({
        ...prevModel,
        page: 0,
      }));
  };
  
  const getCustomerById = (id) => {      
    const cus = allCustomers.find(cus => cus.customerID === id);    
    return cus ? cus : null;
  };

  const handleCloseTagManagementDlg = () => {
    setOpenTagManagementDlg(false);
  }

  const handlePaginationModel = (model) =>{
    if(model.pageSize === -1){
      setPaginationModel({
        page: 0,
        pageSize: -1,
      })
    }else{
      setPaginationModel(model);
    }  
  }

  const handleClearSearch = () => {
    handleSearchChange("");
  };


  // const getDubContent = (dubCustomer) =>{   
  //   let content = `One or more customers named "${customer?.firstName} ${customer?.lastName}" already exist:</br>`;
  //   content +='<div style="overflow-y:auto; max-height:400px">';
  //   for(var i = 0; i< dubCustomer.length; i++){
  //     content += `<p style="display:flex; justify-content: space-between;font-size: medium; "><span> ${i+1}.</span> <span>CustomerID : ${dubCustomer[i].customerID} </span> <span> Name : ${dubCustomer[i].firstName} ${dubCustomer[i].lastName} </span> <a href="./customers/detail/${dubCustomer[i].customerID}" target="_blank">View</a></p>`
  //   }
  //   content += '</div>'
  //   return content;
  // }

  const showBulkConfirmation = (count, message, type,BulkData, btnText) => {
    const confirmButtonText = type === 'Delete' 
    ? 'Yes, delete it' 
    : 'Yes, apply changes';
    MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: message,
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then((result) => {
      if (result.isConfirmed) {
        if(type === 'Delete'){
          handleBulkDelete(); 
        }else if(type === 'Operation'){
          handleBulkSave(BulkData);
        }
              
      }
    });
  };

  const handleGridSelection = (selectedRows) => {
    setSelectedRows(selectedRows);
  };

  const handleBulkCusTypeChange = (value) =>{
    setBulkCusType(value);
  }
  
  const handleBulkCusStatusChange = (value) =>{
    setBulkCusStatus(value);
  }

  const handleBulkCusLeadChange = (value) =>{
    setBulkCusLead(value);
  }

  const handleBulkOperations = async () =>{   
    let BulkData = [];
    let count = Object.values(selectedRows).length;
    if(count > 0 && (bulkCusType || bulkCusStatus || bulkCusLead)){
        for(var i = 0; i< Object.values(selectedRows).length; i++){
          BulkData.push(
            {
              "CustomerID" : Object.values(selectedRows)[i],
              "customerType" : bulkCusType || null,
              "isActive" : bulkCusStatus? bulkCusStatus === 'Active' : null,
              "isLead": bulkCusLead === "yes" ? true : (bulkCusLead === "no" ? false : null),
            }
          )
        }
        showBulkConfirmation(count,`Do you want to make changes on ${count} ${count === 1? 'Customer' : 'Customers'}?`,'Operation',BulkData, 'Yes, do it');
        
        return;
    }else if (!bulkCusType){
      toast.error(`Failed! Please select customer type before proceeding.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    style: {
      fontFamily: '"DM Sans", sans-serif',
      fontSize: '15px',
    },
  });
    } else if (!bulkCusLead){
      toast.error(`Failed! Please select is customer lead before proceeding.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
         style: {
      fontFamily: '"DM Sans", sans-serif',
      fontSize: '15px',
    },
        });
    }
    else if (!bulkCusStatus){
      toast.error(`Failed! Please select status before proceeding.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
         style: {
      fontFamily: '"DM Sans", sans-serif',
      fontSize: '15px',
    },
        });
    }    
  }

  const handleBulkSave = async (BulkData) =>{
    try {   
      NProgress.start();               
      const result = await SaveBulkCustomer(BulkData);
      if (result && !result.isError) {
        await fetchData()                           
        toast.success(`Updated! Customer Information updated successfully.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
           style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
          }); 
          handleClearSelection();          
      } else {
        toast.error(`Failed! ${result.result[0].failureReason}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
           style: {
      fontFamily: '"DM Sans", sans-serif',
      fontSize: '15px',
    },
          });     
          handleClearSelection();       
        console.error('Error saving customer:', result.message);        
      }
    } catch (error) {
      handleClearSelection();
      console.error('Error saving customer:', error);          
    }finally {
      NProgress.done(); 
    }
  }

  const handleBulkDelete = async () => {
    if(Object.values(selectedRows).length > 0){
      for(var i = 0; i< Object.values(selectedRows).length; i++){
        let CusID = Object.values(selectedRows)[i];
        let Cus =  getCustomerById(Object.values(selectedRows)[i]);
        handleDeleteCustomer(CusID,Cus.firstName+' '+Cus.lastName);
      }
    }  
  }

  const handleClearSelection = () => {
    setRowSelectionModel([]);
    setSelectedRows(0);
    setBulkCusStatus(0);
    setBulkCusLead(0);
    setBulkCusType(0);
  };

  const handleDeleteCustomer = async (cusID, Name) =>{  
    NProgress.start();  
      try {
        const result = await DeleteCustomer(cusID,navigate);
        if (result && result.form) {
          console.error(result.form);
          // console.log(result.form);
        } else {
         await fetchData(); 
          // console.log('Customer deleted successfully!'); 
          toast.success(`Deleted! ${Name || 'Data'} has been deleted.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
             style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
            });                 
        }
      } catch (error) {
        console.error('Error deleting customer:', error);      
      }finally {
        NProgress.done(); 
    }
  }

  // Jobsite action handlers
  const handleQuickViewOpen = (jobsiteID) => {
    const jobsite = flattenedJobsitesData.find(j => j.jobsiteID === jobsiteID);
    if (jobsite) {
      // Fetch required data just like in customer details
      fetchAlerts(jobsiteID);
      fetchContacts(jobsite.customerID);
      fetchPropertyArea(jobsiteID);
      setSelectedJobsite(jobsite);
      setQuickViewOpen(true);
    }
  };

  const handleQuickViewClose = () => {
    setQuickViewOpen(false);
    setSelectedJobsite(null);
    setAlertList([]);
    setPropertyAreaList([]);
  };

  const handleJobsiteEdit = (jobsiteID) => {
    const jobsite = flattenedJobsitesData.find(j => j.jobsiteID === jobsiteID);
    if (jobsite) {
      // Find the full jobsite data from allJobsites
      const fullJobsite = allJobsites.find(j => j.jobsiteID === jobsiteID);
      const jobsiteToEdit = fullJobsite || jobsite;
      
      // Ensure the jobsite has the required structure
      const properJobsite = {
        ...jobsiteToEdit,
        jobsiteID: jobsiteToEdit.jobsiteID || 0,
        customerID: jobsiteToEdit.customerID || 0,
        jobsiteName: jobsiteToEdit.jobsiteName || '',
        jobsiteType: jobsiteToEdit.jobsiteType || 'Residential',
        street1: jobsiteToEdit.street1 || '',
        city: jobsiteToEdit.city || '',
        state: jobsiteToEdit.state || '',
        zipCode: jobsiteToEdit.zipCode || '',
        billingAddress: jobsiteToEdit.billingAddress || false,
        isActive: jobsiteToEdit.isActive || false
      };
      
      // Calculate customer name for display
      const customerName = jobsite.customerType === "Business" 
        ? jobsite.companyName 
        : `${jobsite.firstName || ''} ${jobsite.lastName || ''}`.trim();
      
      // Fetch required data just like in customer details
      fetchContacts(properJobsite.customerID);
      fetchPropertyArea(properJobsite.jobsiteID);
      
      setJobsiteForEdit(properJobsite);
      setActiveStepJobsite(0);
      setOpenNewJobsiteDlg(true);
      setJobsiteContent({ 
        title: jobsite.jobsiteName || "Edit Jobsite", 
        customerName: customerName,
        notification: "Jobsite updated successfully.", 
        mode: 'edit' 
      });
    }
  };
  

const handleJobsiteTabbedEdit = (jobsiteID) => {
  const jobsite = flattenedJobsitesData.find(j => j.jobsiteID === jobsiteID);
  if (jobsite) {
   
    const fullJobsite = allJobsites.find(j => j.jobsiteID === jobsiteID);
    const jobsiteToEdit = fullJobsite || jobsite;
    
    // Ensure the jobsite has the required structure
    const properJobsite = {
      ...jobsiteToEdit,
      jobsiteID: jobsiteToEdit.jobsiteID || 0,
      customerID: jobsiteToEdit.customerID || 0,
      jobsiteName: jobsiteToEdit.jobsiteName || '',
      jobsiteType: jobsiteToEdit.jobsiteType || 'Residential',
      street1: jobsiteToEdit.street1 || '',
      city: jobsiteToEdit.city || '',
      state: jobsiteToEdit.state || '',
      zipCode: jobsiteToEdit.zipCode || '',
      billingAddress: jobsiteToEdit.billingAddress || false,
      isActive: jobsiteToEdit.isActive || false
    };
    
    const customerName = jobsite.customerType === "Business" 
      ? jobsite.companyName 
      : `${jobsite.firstName || ''} ${jobsite.lastName || ''}`.trim();
    
    fetchContacts(properJobsite.customerID);
    fetchPropertyArea(properJobsite.jobsiteID);
    
    setJobsiteForEdit(properJobsite);
    setActiveStepJobsite(0);
    setOpenNewJobsiteDlg(true);
    setJobsiteContent({ 
      title: jobsite.jobsiteName || "Edit Jobsite", 
      customerName: customerName,
      notification: "Jobsite updated successfully.", 
      mode: 'tabbed'
    });
  }
};
 const handleCloseNewJobsiteDlg = async (e) => {   
  const escHandler = (event) => {
    if (event.key === "Escape") {
      if (MySwal.isVisible()) {
        MySwal.close();      
      } else {          
        event.stopPropagation();
        event.preventDefault();
      }
    }
  };

  if (jobsiteContent.mode === "tabbed" && jobsiteForEdit) {
    const originalJobsite = flattenedJobsitesData.find(j => j.jobsiteID === jobsiteForEdit.jobsiteID);
    
    const hasChanges = originalJobsite && (
      jobsiteForEdit.jobsiteName !== originalJobsite.jobsiteName ||
      jobsiteForEdit.jobsiteType !== originalJobsite.jobsiteType ||
      jobsiteForEdit.street1 !== originalJobsite.street1 ||
      jobsiteForEdit.city !== originalJobsite.city ||
      jobsiteForEdit.state !== originalJobsite.state ||
      jobsiteForEdit.zipCode !== originalJobsite.zipCode ||
      jobsiteForEdit.billingAddress !== originalJobsite.billingAddress
    );

    if (hasChanges) {     
      document.addEventListener("keydown", escHandler);
      const result = await MySwal.fire({        
        title: '<strong>Are you sure?</strong>',
        html: '<span>Any unsaved changes will be discarded. Do you want to proceed?</span>',
        showCancelButton: true,
        confirmButtonText: 'Yes, discard changes!',
        cancelButtonText: 'No, stay here',
        width: '420px',
        padding: '1rem',
        focusConfirm: false,
        showCloseButton: true,
        closeButtonHtml: '&times;',
        customClass: {
          popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
          cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
        },
        didClose: () => {        
          document.removeEventListener("keydown", escHandler);
        },
      });
      
      if (result.isConfirmed) {
        setOpenNewJobsiteDlg(false); 
        setJobsiteForEdit(null);
        setActiveStepJobsite(0);
      }
      return; // Important: return here to prevent further execution
    }
  }
  
  // No unsaved changes or not in tabbed mode, close normally
  setOpenNewJobsiteDlg(false);
  setJobsiteForEdit(null);
  setActiveStepJobsite(0);
};

  const handleJobsiteChange = (field, value) => {
    setJobsiteForEdit(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const clearAreaMeasurement = () => {
    setAreaMeasurement({});
  };

  const clearPropertyArea = () => {
    setPropertyArea({});
  };

  const fetchPropertyArea = async (jobsiteID) => {
    try {
      let propertyAreas = await GetPropertyArea(jobsiteID, 0, navigate);
      setPropertyAreaList(propertyAreas);
    } catch (error) {
      console.error("Error fetching Property Area data:", error);
      setPropertyAreaList([]);
    }
  };

  const fetchAlerts = async (jobsiteID) => {
    try {
      let alrts = await GetAlerts(jobsiteID, 0, navigate);
      setAlertList(alrts);
    } catch (error) {
      console.error("Error fetching Alerts data:", error);
      setAlertList([]);
    }
  };

  const fetchContacts = async (customerID) => {
    try {
      let contacts = await GetContacts(customerID || 0);
      setAllContacts(contacts);
    } catch (error) {
      console.error("Error fetching Contacts data:", error);
      setAllContacts([]);
    }
  };

  const handleJobsiteDelete = async (jobsiteID, jobsiteName) => {
    const jobsite = flattenedJobsitesData.find(j => j.jobsiteID === jobsiteID);
    if (!jobsite) return;

    try {
      const result = await MySwal.fire({
        title: '<strong>Are you sure?</strong>',
        html: `Do you want to delete "${jobsiteName}"? You won't be able to revert this!`,
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'No, keep it',
        focusConfirm: false,
        showCloseButton: true,
        customClass: {
          popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
          cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
        }
      });

      if (result.isConfirmed) {
        setLoading(true);
        const deleteResult = await DeleteJobsite(jobsiteID, jobsite.customerID, navigate);
        
        if (deleteResult && !deleteResult.isError) {
          await fetchData(); // Refresh the data
          toast.success(`"${jobsiteName}" Jobsite deleted successfully.`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
             style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
          });
        } else {
          toast.error(deleteResult.message || 'Failed to delete the jobsite.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
             style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
          });
        }
      }
    } catch (error) {
      console.error('Error deleting jobsite:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenBulkImportCustomerDlg = () => {
    setBulkImportContent({title:'Customers', ImportURL:'/onboarding/add-customer', customerID: 0})
    setOpenBulkImportDlg(true);   
  };
  const handleOpenBulkImportCustomerWithJobsitesDlg = () => {
    setBulkImportContent({title:'Customers with Jobsites', ImportURL:'/onboarding/add-customer-with-jobsites', customerID: 0})
    setOpenBulkImportDlg(true);   
  };
  const handleOpenBulkImportCustomerWithContactsDlg = () => {
    setBulkImportContent({title:'Customers with Contacts', ImportURL:'/onboarding/add-customer-with-contacts', customerID: 0})
    setOpenBulkImportDlg(true);   
  };
    
  const handleCloseBulkImportDlg = () => {
    setOpenBulkImportDlg(false);    
  };

  const handleCSVExport = () => {
    if(exportToCSV(allCustomers, `Customers [${getCurrentDate()}].csv`, { delimiter: ',', includeHeaders: true })){
      Swal.fire({
        title: "Exported!",
        text: "Data has been successfully exported!",
        icon: "success",
        confirmButtonColor: "#23a26d",
        customClass: {
          popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          htmlContainer: "custom-swal-html",
          confirmButton: "custom-swal-confirm",
        },
      });
    }else{
      Swal.fire(
        {
          title: 'Failed!',
          text: 'No data available to export!',
          icon: 'error',
          confirmButtonColor: '#23a26d', 
           customClass: {
            popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
             htmlContainer: 'custom-swal-html',
             confirmButton: 'custom-swal-confirm',
           },
        });
    }
    
  };

  const handleExcelExport = () =>{
    if(ExportToExcel(allCustomers, `Customers [${getCurrentDate()}]`)){
      Swal.fire(
        {
          title: 'Exported!',
          text: 'Data has been successfully exported!',
          icon: 'success',
          confirmButtonColor: '#23a26d', 
        });
      }else{
        Swal.fire(
          {
            title: 'Failed!',
            text: 'No data available to export!',
            icon: 'error',
            confirmButtonColor: '#23a26d', 
          });
      }
  }

  const buttons = [
    { name: "All", searchKeyWord: "" },
    { name: "Customers", searchKeyWord: "NL" },
    { name: "Leads", searchKeyWord: "Lead" },
    { name: "Jobsites", searchKeyWord: "Jobsites" },
  ];

  const NoRowsOverlay = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          padding: 2,
        }}
      >
        <Typography variant="h6" color="secondary">
          Oops! No Data Found
        </Typography>
      </Box>
    );
  };

  //#endregion end of handlers and methods

  const IndexProps = {
    tagManagementData,
    openNewCustomerDlg,
    data,
    loading,    
    contentHeightFixed,
    buttons,
    selectedButton,
    paginationText,
    searchText,
    bulkCusType,  
    bulkCusStatus, 
    bulkCusLead,  
    selectedRows,
    columns,
    paginationModel,
    rowSelectionModel,
    openBulkImportDlg,
    EmpFiles,
    btnLoader,
    openTagManagementDlg,
    bulkTags,    
    filteredRows,
    BulkImportContent,
    getRootProps,
    getInputProps,
    setBulkTags,
    setEmpFiles,  
    setRowSelectionModel,
    handleSearchChange,
    navigate,
    handleOpenNewCustomerDlg,
    setLoading,
    NoRowsOverlay,
    handleExcelExport,
    handleCSVExport,
    handleCloseBulkImportDlg,
    handleOpenBulkImportCustomerDlg,
    handleOpenBulkImportCustomerWithJobsitesDlg,
    handleOpenBulkImportCustomerWithContactsDlg,
    handleClearSelection,
    handleBulkOperations,
    handleBulkCusLeadChange,
    handleBulkCusStatusChange,
    handleBulkCusTypeChange,
    handleGridSelection,
    showBulkConfirmation,
    handleClearSearch,
    handlePaginationModel,
    handleCloseTagManagementDlg,
    handleFilterTypeChange,
    handleOpenTagManagementDlg,
    handleReset,
    applyFilters, 
    setOpenNewCustomerDlg,
    filteredData,  
    fetchData, 
    allCustomers, 
    allJobsites,
    setAllCustomers,
    handleAddTag,
    handleDeleteTag,
    Tag,
    setTag,
    customer,
    hasSavePermission,
    showJobsites,
    flattenedJobsitesData,
    jobsitesColumns,
    quickViewOpen,
    selectedJobsite,
    alertList,
    propertyAreaList,
    handleQuickViewOpen,
    handleQuickViewClose,
    handleJobsiteEdit,
    handleJobsiteTabbedEdit,
    handleJobsiteDelete,
    hasJobsiteSavePermission,
    hasJobsiteDeletePermission,
    openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    jobsiteForEdit,
    jobsiteContent,
    handleCloseNewJobsiteDlg,
    handleJobsiteChange,
    activeStepJobsite,
    setActiveStepJobsite,
    propertyArea,
    setPropertyArea,
    areaMeasurement,
    setAreaMeasurement,
    clearAreaMeasurement,
    fetchPropertyArea,
    clearPropertyArea,
    files,
    setFiles,
    listOfMeasurements,
    setListOfMeasurements,
    fetchAlerts,
    fetchContacts,
    allContacts,
    setAllContacts,
    setAlertList,
    filteredJobsitesRows,
  }

  return {    
    IndexProps
  };
}
